import { IInterest, ILoggedCustomer, ITenant, IUsageType } from "api/types";
import gql from "graphql-tag";
import * as React from "react";
import { Query } from "react-apollo";

interface ITenantData {
  id: string;
  whiteLabelMode: boolean;
  interests: IInterest[];
  usageTypes: IUsageType[];
}

export const TenantDataContext = React.createContext<ITenantData | undefined>(
  undefined
);

interface IProps {
  children: React.ReactNode;
}

export default ({ children }: IProps) => {
  return (
    <Query
      query={gql`
        query tenantData {
          tenant {
            id
            whiteLabelMode
          }
          availableSegmentationDetails {
            interests {
              id
              name
              image
            }
            usageTypes {
              id
              name
            }
          }
        }
      `}
      fetchPolicy="cache-and-network"
    >
      {({ data }) => {
        const tenantData: ITenantData =
          (data && {
            ...data.tenant,
            ...data.availableSegmentationDetails
          }) ||
          undefined;

        return (
          <TenantDataContext.Provider value={tenantData}>
            {children}
          </TenantDataContext.Provider>
        );
      }}
    </Query>
  );
};



// WEBPACK FOOTER //
// ./src/components/Gates/TenantDataGate.tsx